var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:{ 
        'chip': true, 
        'chip_open' : _vm.value == 'open', 
        'chip_void' : _vm.value == 'void', 
        'chip_ready' : _vm.value =='ready-to-process' ,
        'chip_processed_success' : _vm.value == 'processed-success',
        'chip_processed_failed' : _vm.value == 'processed-error',
    }},[_vm._v(" "+_vm._s(_vm.label)+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }